import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import store from "../store";
import { Provider } from 'react-redux';
import { Routes } from "../routes/Routes";
import BackgroundService from './BackgroundService';

function App() {
  return (
    <Provider store={store}>
      <div id="popup" />
      <BackgroundService />
      <Router>
        <Routes />
      </Router>
    </Provider>
  );
}

export default App;
